const routes = {
  path: '/workspace',
  component: () => import('@/components/layout/index.vue'),
  alwaysShow: true,
  meta: {
    title: '工作台',
    icon: 'icongongzuotai'
  },
  children: [
    {
      path: 'welcome',
      name: 'Welcome',
      component: () => import('@/views/workspace/welcome.vue'),
      meta: {
        title: '欢迎页',
        isHideBread: true
      }
    },
    {
      path: 'userCenter',
      name: 'UserCenter',
      component: () => import('@/views/userCenter/index'),
      meta: {
        title: '个人资料',
      }
    },
    {
      path: 'message/list',
      name: 'MessageCenter',
      component: () => import('@/views/workspace/message/index'),
      meta: {
        title: '消息中心',
      }
    },
    {
      path: 'task/list',
      name: 'TaskList',
      component: () => import('@/views/task/index'),
      meta: {
        title: '待办任务',
        type: 'approve'
      }
    },
    {
      path: 'project/list',
      name: 'FirmProjectList',
      component: () => import('@/views/firm/project/list.vue'),
      meta: {
        title: '项目管理',
        permission: 'project.list',
      }
    },
    {
      path: 'notice/list',
      name: 'NoticeList',
      hidden:true,
      component: () => import('@/views/workspace/noticeList.vue'),
      meta: {
        title: '公告',
      }
    },
    {
      path: 'fileTask/list',
      name: 'WorkspaceFileTask',
      hidden:true,
      component: () => import('@/views/workspace/task.vue'),
      meta: {
        title: '任务列表',
      }
    },
  ]
}
export default routes;